// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"c82e33467f2e65818d19","532":"029eb323d6abb3a52d0c","678":"7c55fce7df95f0ffc403","883":"98ac3c9765595e5bb1f0"}[chunkId] + ".js";
};